/* Golden Outlet — pont vers la page de paiement maison (pay.golden-outlet-fr.com).
   Tout bouton « Procéder au paiement » (tiroir panier, page panier) mène à la page de
   paiement hébergée (pay.maisonvolt-fr.com, Apple Pay / Google Pay possibles) : le panier
   Shopify est transmis, la page de paiement est ouverte avec son identifiant. Si cette
   transmission échoue (réseau), on retombe sur /pages/paiement dans le thème.
   Les boutons de paiement dynamique Shopify sont masqués par CSS.
   Paiement accéléré : sur Safari avec Apple Pay, un bouton Apple Pay est ajouté sous « Procéder au
   paiement » (tiroir panier et page panier). Il mène à la page de paiement hébergée, où la fiche
   Apple Pay s'ouvre en tête de page (la fiche ne peut pas s'ouvrir sur le domaine Shopify). */
(function () {
  var FALLBACK = '/checkout';
  var HANDOFF = 'https://pay.golden-outlet-fr.com/api/checkout/handoff';
  var EXPRESS_FLAG = '?express=apple';
  var busy = false;
  function isCheckoutControl(el) {
    if (!el) return false;
    if (el.name === 'checkout') return true;
    if (el.id === 'checkout' || el.id === 'CartDrawer-Checkout') return true;
    if (el.classList && el.classList.contains('cart__checkout-button')) return true;
    if (el.tagName === 'A') {
      var href = el.getAttribute('href') || '';
      if (/^\/checkout(\b|\/|\?|$)/.test(href)) return true;
    }
    return false;
  }
  function withTimeout(p, ms) {
    return new Promise(function (resolve, reject) {
      var t = setTimeout(function () { reject(new Error('timeout')); }, ms);
      p.then(function (v) { clearTimeout(t); resolve(v); }, function (e) { clearTimeout(t); reject(e); });
    });
  }
  function go(e, el, express) {
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    busy = true;
    if (el && 'disabled' in el) el.disabled = true;
    var shop = (window.Shopify && window.Shopify.shop) || location.hostname;
    withTimeout(fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }), 8000)
      .then(function (cart) {
        var items = (cart.items || []).map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity, properties: i.properties || {} }; });
        if (!items.length) throw new Error('panier vide');
        return withTimeout(fetch(HANDOFF, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ shop: shop, cart_token: cart.token, items: items }), credentials: 'omit' }), 10000);
      })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (!j || !j.url) throw new Error('réponse invalide'); window.location.href = j.url + (express ? EXPRESS_FLAG : ''); })
      .catch(function () { window.location.href = FALLBACK; });
  }
  function canApplePay() { try { return !!(window.ApplePaySession && window.ApplePaySession.canMakePayments()); } catch (err) { return false; } }
  function addApplePayButtons() {
    if (!canApplePay()) return;
    var targets = document.querySelectorAll('#CartDrawer-Checkout, #checkout, .cart__checkout-button, button[name="checkout"]');
    Array.prototype.forEach.call(targets, function (btn) {
      if (!btn.parentNode || btn.parentNode.querySelector('.mv-apay')) return;
      var wrap = document.createElement('div');
      wrap.className = 'mv-apay-wrap';
      wrap.innerHTML = '<p class="mv-apay-note">Paiement accéléré</p><button type="button" class="mv-apay" aria-label="Acheter avec Apple Pay"></button>';
      btn.insertAdjacentElement('afterend', wrap);
      wrap.querySelector('.mv-apay').addEventListener('click', function (e) { go(e, this, true); });
    });
  }
  function initApplePay() {
    if (!canApplePay()) return;
    var style = document.createElement('style');
    style.textContent = '.mv-apay-wrap{margin:1.2rem 0 0}.mv-apay-note{margin:0 0 .6rem;text-align:center;font-size:1.1rem;letter-spacing:.08em;text-transform:uppercase;opacity:.65}.mv-apay{display:block;width:100%;height:4.8rem;margin:0;padding:0;border:0;border-radius:var(--buttons-radius-outset,0);cursor:pointer;-webkit-appearance:-apple-pay-button;-apple-pay-button-type:buy;-apple-pay-button-style:black}';
    document.head.appendChild(style);
    addApplePayButtons();
    new MutationObserver(function () { addApplePayButtons(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initApplePay); else initApplePay();
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('button, input[type="submit"], a') : null;
    if (isCheckoutControl(el)) go(e, el);
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    var submitter = e.submitter;
    if (f && /\/cart\/?$/.test(f.getAttribute('action') || '') && isCheckoutControl(submitter)) go(e, submitter);
  }, true);
})();
